import { Stack, Typography, Card } from "@mui/material";

export const NewFormCardWrapper = ({
  children,
  title,
  gap = "16px",
  bodyGap = "12px",
  titleColor = "gray.50",
  sx = {},
}) => {
  return (
    <Stack component={Card} sx={{ p: "24px", gap: gap, ...sx }}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: titleColor,
          textTransform: "uppercase",
        }}
      >
        {title}
      </Typography>
      <Stack sx={{ gap: bodyGap }}>{children}</Stack>
    </Stack>
  );
};
